import React from 'react';
import type { CardProps } from '@usealloy/component-library';
import { Card } from '@usealloy/component-library';
import styled from 'styled-components';

const CollapsiboxWrapper = styled(Card)`
  background-color: var(--cl-background-default);
`;

type CollapsiboxProps = CardProps & {
  secondHeader?: string;
};

const Collapsibox: React.FC<CollapsiboxProps> = props => (
  <CollapsiboxWrapper
    collapsible
    {...props}
  />
);

export default Collapsibox;
